export const USFlag = ({ width = "640px", height = "480px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <path
        fill={"#41479b"}
        d="M473.655 88.276H38.345C17.167 88.276 0 105.443 0 126.621V385.38c0 21.177 17.167 38.345 38.345 38.345h435.31c21.177 0 38.345-17.167 38.345-38.345V126.621c0-21.178-17.167-38.345-38.345-38.345"
      />
      <path
        fill={"#f5f5f5"}
        d="M511.469 120.282c-3.022-18.159-18.797-32.007-37.814-32.007h-9.977l-163.54 107.147V88.276h-88.276v107.147L48.322 88.276h-9.977c-19.017 0-34.792 13.847-37.814 32.007l139.778 91.58H0v88.276h140.309L.531 391.717c3.022 18.159 18.797 32.007 37.814 32.007h9.977l163.54-107.147v107.147h88.276V316.577l163.54 107.147h9.977c19.017 0 34.792-13.847 37.814-32.007l-139.778-91.58H512v-88.276H371.691z"
      />
      <path
        fill={"#ff4b55"}
        d="M282.483 88.276h-52.966v141.241H0v52.966h229.517v141.241h52.966V282.483H512v-52.966H282.483z"
      />
      <path
        fill={"#ff4b55"}
        d="m24.793 421.252 186.583-121.114h-32.428L9.224 410.31a38.4 38.4 0 0 0 15.569 10.942m321.595-121.114H313.96l180.716 117.305a38.5 38.5 0 0 0 12.287-13.075zM4.049 109.475l157.73 102.387h32.428L15.475 95.842a38.5 38.5 0 0 0-11.426 13.633m328.517 102.387 170.035-110.375a38.4 38.4 0 0 0-15.699-10.86L300.138 211.862z"
      />
    </svg>
  );
};
